<template>
  <div class="row mt-1">
    <div class="col-sm-12">
      <div class="title font-weight-light theme-text float-left">{{ data.title }}</div>
      <div class="grey--text text--darken-2 text-body-2 mt-2 float-right">{{ data.date }}</div>
    </div>
    <div class="col-sm-12">
      <v-list two-line dense class="mt-n3">
        <template v-for="item in data.data">
          <v-list-item :key="item.id">
            <v-list-item-avatar v-if="item.type==='timeoff'">
              <v-img :src="item.url"></v-img>
            </v-list-item-avatar>
            <v-list-item-avatar v-else-if="item.type==='holiday'">
              <v-icon class="theme" dark>beach_access</v-icon>
            </v-list-item-avatar>
            <v-list-item-avatar v-else>
              <v-img v-if="item.url" :src="item.url"/>
              <v-icon v-else>account_circle</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-text="item.name"></v-list-item-title>
              <v-list-item-subtitle v-text="item.date"></v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-if="item.description">
              <v-btn icon>
                <v-icon color="pink darken-4">{{ getIconForDescription(item) }}</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-list>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimelineSmall',
  props: ['data'],
};
</script>